import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_PERMISE_LOADING = 'GET_PERMISE_LOADING';
export const GET_PERMISE_SUCCESS = 'GET_PERMISE_SUCCESS';
export const GET_PERMISE_REJECT = 'GET_PERMISE_REJECT';

//* ACTIONS ------------------------------------------------
export const getPermiseLoading = () => ({ type: GET_PERMISE_LOADING });
export const getPermiseSuccess = (payload) => ({ type: GET_PERMISE_SUCCESS, payload });
export const getPermiseReject = (payload) => ({ type: GET_PERMISE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getPermiseRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Profiles/web/GetOptionsPermises/${id}`, options);
};